import { InsuredBadge } from 'app/design/icons/insured-badge';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

export function HelpCompensationSubscribeBanner({
  actions,
}: {
  actions?: {
    onLearnMore: () => void;
    onSubscribe: () => void;
  };
}) {
  const theme = useTheme();
  const { t } = useTranslation('help');

  return (
    <Column
      gap="spacing.general.x4"
      style={{
        backgroundColor: theme.colors['surface.primary-neutral'],
        borderRadius: theme.borderRadii['radius.lg'],
        padding: theme.spacing['spacing.general.x4'],
      }}
    >
      <Row alignItems="flex-start" gap="spacing.general.x4">
        <InsuredBadge />
        <Column flex={1} gap="spacing.general.x1">
          <Text fontWeight="700" variant="bodyBase">
            {t('compensation.title')}
          </Text>
          <Text fontSize={14} variant="bodyBase">
            {t('compensation.subscribeText')}
          </Text>
        </Column>
      </Row>
      {actions ? (
        <Row alignItems="center" gap="spacing.general.x4" flexWrap="wrap">
          <Button flex={1} onPress={actions.onSubscribe} variant="whiteWithBorder">
            <Text fontWeight="700" variant="bodyBase">
              {t('compensation.subscribeCta')}
            </Text>
          </Button>
          <Pressable onPress={actions.onLearnMore}>
            <Text fontSize={15} fontWeight="600" style={{ textDecorationLine: 'underline' }} variant="bodyBase">
              {t('compensation.learnMore')}
            </Text>
          </Pressable>
        </Row>
      ) : null}
    </Column>
  );
}
